import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const STATIC_BASE = BACKEND_URL;

export function staticImg(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${STATIC_BASE}${path}`;
}

export const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

export async function createLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function getCollections() {
  const { data } = await api.get("/collections");
  return data;
}

export async function getCollection(slug) {
  const { data } = await api.get(`/collections/${slug}`);
  return data;
}

export async function getProjects(params = {}) {
  const { data } = await api.get("/projects", { params });
  return data;
}

export async function getProject(slug) {
  const { data } = await api.get(`/projects/${slug}`);
  return data;
}

export async function getMaterials() {
  const { data } = await api.get("/materials");
  return data;
}

export async function getAppointmentSlots(date) {
  const { data } = await api.get("/appointment/slots", { params: { date } });
  return data;
}
